import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * KVKK olayları (Prompt 17, ADR 0017 §7–10). Yük KİŞİSEL VERİ TAŞIMAZ: başvuranın adı / iletişimi, telefon, e-posta ve
 * ileti metni olaya girmez; kimlikler, kodlar ve sayılar taşınır.
 */
export const privacyConsentRecordedV1 = defineEvent({
    type: "privacy.consent.recorded",
    version: 1,
    description: "Müşterinin aydınlatma / açık rıza / ticari ileti metnine kararı deftere yazıldı",
    realtime: ["tenant"],
    payload: z.object({
        consentRecordId: z.uuid(),
        customerProfileId: z.uuid(),
        privacyTextId: z.uuid(),
        kind: z.string(),
        purposeCode: z.string().nullable(),
        decision: z.string(),
        channel: z.string(),
    }),
});
export const privacyMessagePermissionChangedV1 = defineEvent({
    type: "privacy.message_permission.changed",
    version: 1,
    description: "Ticari elektronik ileti izni değişti (İYS'ye gönderilmek üzere bekliyor)",
    realtime: ["tenant"],
    payload: z.object({
        permissionId: z.uuid(),
        customerProfileId: z.uuid(),
        channel: z.string(),
        decision: z.enum(["GRANTED", "REVOKED"]),
    }),
});
const requestBase = {
    requestId: z.uuid(),
    requestNo: z.string(),
    requestType: z.string(),
    customerProfileId: z.uuid().nullable(),
    dueAt: z.iso.datetime({ offset: true }),
};
export const privacyRequestReceivedV1 = defineEvent({
    type: "privacy.request.received",
    version: 1,
    description: "İlgili kişi başvurusu alındı (son gün hesaplandı)",
    realtime: ["tenant"],
    payload: z.object({ ...requestBase, channel: z.string() }),
});
export const privacyRequestDueSoonV1 = defineEvent({
    type: "privacy.request.due_soon",
    version: 1,
    description: "İlgili kişi başvurusunun son gününe az kaldı (başvuru başına bir kez)",
    realtime: ["tenant"],
    payload: z.object({ ...requestBase, daysLeft: z.number().int() }),
});
export const privacyRequestOverdueV1 = defineEvent({
    type: "privacy.request.overdue",
    version: 1,
    description: "İlgili kişi başvurusunun yanıt süresi geçti (başvuru başına bir kez)",
    realtime: ["tenant"],
    payload: z.object(requestBase),
});
export const privacyRequestCompletedV1 = defineEvent({
    type: "privacy.request.completed",
    version: 1,
    description: "İlgili kişi başvurusu sonuçlandı (tamamlandı ya da reddedildi)",
    realtime: ["tenant"],
    payload: z.object({
        ...requestBase,
        status: z.enum(["COMPLETED", "REJECTED"]),
        anonymized: z.boolean(),
        exported: z.boolean(),
    }),
});
export const marketingBatchSentV1 = defineEvent({
    type: "marketing.batch.sent",
    version: 1,
    description: "Pazarlama iletisi partisi işlendi (izin gönderim anında denetlendi; sayılar)",
    realtime: ["tenant"],
    payload: z.object({
        batchId: z.uuid(),
        channel: z.enum(["SMS", "EMAIL"]),
        total: z.number().int(),
        sent: z.number().int(),
        skippedNoPermission: z.number().int(),
        skippedNoContact: z.number().int(),
        skippedAnonymized: z.number().int(),
        failed: z.number().int(),
    }),
});
//# sourceMappingURL=privacy.v1.js.map